import * as angular from 'angular';

export class ReverseAuctionUploadWizardService {
    public getMappedData(stageFourData): ManualReverseAuctionUploadDto {
        var data = {
            competition: {
                totalCapacity: 0,
                idsOfCompetingProducts: []
            },
            reverseAuctions: []
        };

        if (
            angular.isUndefined(stageFourData) ||
            stageFourData === null ||
            angular.equals(stageFourData, {}) ||
            !stageFourData.transferData
        ) {
            return data;
        }

        angular.forEach(stageFourData.transferData, (productWrapper) => {
            let dataProduct = {
                accessPointRefId: productWrapper.networkPoint.id,
                capacityCategory: productWrapper.categoryType,
                offerId: productWrapper.offerId,
                runtime: productWrapper.runtime,
                quantityDto: productWrapper.amount,
                productCharacter: productWrapper.productCharacter,
                productType: productWrapper.productType,
                pricingType: productWrapper.pricingAlgorithm,
                priceCapValue: this.getOriginalValue(productWrapper.priceCap),
                priceCapUnit: this.getPriceUnitDto(productWrapper.priceCap),
                publicationTime: productWrapper.publication,
                auctionRuntime: {
                    start: productWrapper.auctionStart,
                    end: productWrapper.auctionEnd
                }
            };
            data.reverseAuctions.push(dataProduct);
            data.competition.idsOfCompetingProducts.push(
                productWrapper.offerId
            );
        });
        if (stageFourData.competition) {
            data.competition.totalCapacity = this.getCompetitionValue(
                stageFourData.competition
            );
        } else {
            delete data.competition;
        }

        return data;
    }

    private getPriceUnitDto(item) {
        if (
            angular.isUndefined(item) ||
            angular.isUndefined(item.originalUnit)
        ) {
            return null;
        }

        let priceUnitDto = {
            currency: item.originalUnit.currency,
            currencySubunit: item.originalUnit.currencySubunit,
            label: item.originalUnit.label,
            physicalUnit: item.originalUnit.physicalUnit,
            unspecificPeriod: item.originalUnit.unspecificPeriod
        };
        return priceUnitDto;
    }

    private getOriginalValue(item) {
        if (
            angular.isUndefined(item) ||
            angular.isUndefined(item.originalValue)
        ) {
            return null;
        }
        return item.originalValue;
    }

    private getCompetitionValue(item) {
        if (
            angular.isUndefined(item) ||
            angular.isUndefined(item.value.value)
        ) {
            return null;
        }
        let mapCompetition = item.value.value;

        return mapCompetition;
    }
}

angular
    .module('app')
    .service(
        'reverseAuctionUploadWizardService',
        ReverseAuctionUploadWizardService
    );
